import { render, staticRenderFns } from "./CargoMthlyStats.vue?vue&type=template&id=dfe02e28&"
import script from "./CargoMthlyStats.vue?vue&type=script&lang=js&"
export * from "./CargoMthlyStats.vue?vue&type=script&lang=js&"
import style0 from "./CargoMthlyStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoMthlyStats.vue"
export default component.exports